export default __webpack_public_path__ + "static/media/slayt_square.413b4a55.jpg";